import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined'
import {DropdownItem} from '@viptech/react-components'
import {useEffect} from 'react'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import SearchIconInputSmallChangeColor from '../../images/SearchIconInputSmall'
import Dropdown from '../dropdown/Dropdown'
import {Input} from '../input/Input'
import Separation from '../separation/Separation'
import {
  AdvancedFiltersWrapper,
  ButtonResponsive,
  ContainerBaseInput,
  ContainerBaseInputResponsive,
  SelectWithSearchWrapper,
} from './SelectWithSearchComponentBase'

export type MultipleSearchDropdownItem = {
  id: string
  label: string
  searchBy: string
}

export type SelectWithSearchComponentProps = {
  searchBy: DropdownItem[]
  searchSelected: DropdownItem | MultipleSearchDropdownItem
  setSearchSelected: (search: any) => void
  inputSearch: (input: string) => void
  inputValue?: string
  filterBy?: DropdownItem[]
  setSelectedFilter?: (selected: any) => void
  disabledSelectFilter?: boolean
  multipleSearch?: boolean
  handleMultipleSearch?: () => void
  widthOnSelect?: string
  dontSetSearchBy?: boolean
  hideAdvancedFilters?: boolean
}

export function SelectWithSearchComponent(props: SelectWithSearchComponentProps) {
  const {
    searchBy,
    multipleSearch,
    handleMultipleSearch,
    setSearchSelected,
    searchSelected,
    filterBy,
    setSelectedFilter,
    inputSearch,
    inputValue,
    disabledSelectFilter,
    widthOnSelect,
    dontSetSearchBy,
    hideAdvancedFilters,
  } = props

  useEffect(() => {
    if (!dontSetSearchBy) setSearchSelected(searchBy[0])
  }, [searchBy])

  const {styledTheme} = usePersonalizedThemeByCompany()

  return (
    <SelectWithSearchWrapper>
      <ContainerBaseInput>
        <Dropdown
          width={widthOnSelect ?? '150px'}
          fontSize='14px'
          labelFontSize='14px'
          borderColor='transparent'
          bgColor='white'
          items={searchBy}
          disabledBorderColor
          selected={searchSelected}
          preventEditing={true}
          onChangeSelected={(e) => setSearchSelected(e)}
        />

        <Separation height='80%' width='1px' color='#9aa4b2' />

        <Input.Root
          fontSize='14px'
          controlled
          value={inputValue || ''}
          placeholder='Pesquisar'
          placeholderColor={inputValue ? styledTheme.colors.primary : 'gray'}
          borderColor='transparent'
          bgColor='transparent'
          disabledBorderOnFocus
          onChange={(e) => inputSearch(e.target.value)}
          onKeyDown={inputValue ? (e) => e.key === 'Enter' && handleMultipleSearch?.() : undefined}
          leftIcon=<SearchIconInputSmallChangeColor color={styledTheme.colors.primary} />
        />

        {multipleSearch && inputValue && (
          <ButtonResponsive disabled={!inputValue} onClick={() => handleMultipleSearch?.()}>
            <PostAddOutlinedIcon color={!inputValue ? 'disabled' : 'primary'} />
          </ButtonResponsive>
        )}
      </ContainerBaseInput>

      <ContainerBaseInputResponsive>
        <Input.Root
          fontSize='14px'
          controlled
          value={inputValue || ''}
          placeholder='Pesquisar'
          placeholderColor={inputValue ? styledTheme.colors.primary : 'gray'}
          borderColor='transparent'
          bgColor='transparent'
          disabledBorderOnFocus
          width='100%'
          onChange={(e) => inputSearch(e.target.value)}
          leftIcon={<SearchIconInputSmallChangeColor color={styledTheme.colors.primary} />}
        />
      </ContainerBaseInputResponsive>

      {!hideAdvancedFilters && filterBy && (
        <AdvancedFiltersWrapper>
          <Dropdown
            className='pai'
            height='40px'
            width='160px'
            fontSize='14px'
            labelFontSize='14px'
            borderColor={styledTheme.colors.primary}
            bgColor='white'
            iconColor={styledTheme.colors.primary}
            placeholder='Adicionar Filtro'
            items={filterBy}
            placeholderColor={styledTheme.colors.primary}
            disabled={disabledSelectFilter}
            onChangeSelected={(e) => setSelectedFilter?.(e)}
            dontReflectValueSelectedOnLabel
          />
        </AdvancedFiltersWrapper>
      )}
    </SelectWithSearchWrapper>
  )
}
